import { render, staticRenderFns } from "./BulkImportComponent.vue?vue&type=template&id=4252a492&scoped=true&"
import script from "./BulkImportComponent.vue?vue&type=script&lang=js&"
export * from "./BulkImportComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulkImportComponent.vue?vue&type=style&index=0&id=4252a492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252a492",
  null
  
)

export default component.exports